import type { ToothSliceGeometry } from '../config';

const geometryByToothID = new Map<string, ToothSliceGeometry>();

export const rememberToothSliceGeometry = (geometry: ToothSliceGeometry) => {
  geometryByToothID.set(geometry.toothID, geometry);
};

export const findToothSliceGeometryByIso = ({
  iso,
  volumeFileID,
}: {
  iso: number;
  volumeFileID: string;
}): ToothSliceGeometry | null =>
  [...geometryByToothID.values()].find(
    (geometry) =>
      geometry.numeration.iso === iso && geometry.volumeFileID === volumeFileID,
  ) ?? null;
